import React, { useEffect, memo } from 'react';
import { View, StyleSheet } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, Reanimated3DefaultSpringConfig, withSpring, } from 'react-native-reanimated';
import { rem } from 'design-system';
const springConfig = {
    ...Reanimated3DefaultSpringConfig,
    mass: 0.8,
    stiffness: 100,
};
const Bar = ({ color, height, positiveYMaxHeight, negativeYMaxHeight }) => {
    const animatedHeight = useSharedValue(0);
    const isFirstLoad = useSharedValue(true);
    const animatedHeightStyles = useAnimatedStyle(() => ({
        height: animatedHeight.value,
    }), [animatedHeight]);
    useEffect(() => {
        const toValue = Math.abs(height);
        if (isFirstLoad.value === true) {
            isFirstLoad.value = false;
            const timeout = setTimeout(() => {
                animatedHeight.value = withSpring(toValue, springConfig);
            }, 300);
            return () => {
                clearTimeout(timeout);
            };
        }
        animatedHeight.value = withSpring(toValue, springConfig);
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [height]);
    return height >= 0 ? (<View style={[styles.positiveContainer, { height: positiveYMaxHeight, marginBottom: negativeYMaxHeight }]}>
      <Animated.View style={[styles.positiveBar, { backgroundColor: color }, animatedHeightStyles]}/>
    </View>) : (<View style={{ height: negativeYMaxHeight, marginTop: positiveYMaxHeight }}>
      <Animated.View style={[styles.negativeBar, { backgroundColor: color }, animatedHeightStyles]}/>
    </View>);
};
export default memo(Bar);
const styles = StyleSheet.create({
    positiveContainer: {
        justifyContent: 'flex-end',
    },
    negativeBar: {
        width: rem(14),
        borderBottomLeftRadius: rem(4),
        borderBottomRightRadius: rem(4),
    },
    positiveBar: {
        width: rem(14),
        borderTopLeftRadius: rem(4),
        borderTopRightRadius: rem(4),
    },
});
